/** @jsx jsx */
import { jsx } from 'theme-ui'
import Collection from './collection'
import { Container } from './helpers/react'

const removeSpacing = (props) => {
  return {
    ...props,
    entries: props.entries.map((e) => ({
      ...e,
      removeTopSpacing: true,
      removeBottomSpacing: true,
    })),
  }
}

const CollectionModuleWrapper = (props: any) => {
  if (props.gridVerticalAligment) {
    const verticalAlignmentMap = {
      top: 'flex-start',
      center: 'center',
      bottom: 'flex-end',
    }

    const alignItems = verticalAlignmentMap[props.gridVerticalAligment]
    const options = {
      ...props.options,
      styles: {
        ...props.options?.styles,
        col: {
          ...props.options?.styles?.col,
          alignItems,
        },
      },
    }

    return (
      <Choose>
        <When condition={props.useContainer}>
          <Container>
            <Collection {...removeSpacing(props)} options={options} />
          </Container>
        </When>
        <Otherwise>
          <Collection {...removeSpacing(props)} options={options} />
        </Otherwise>
      </Choose>
    )
  }

  return (
    <Choose>
      <When condition={props.useContainer}>
        <Container>
          <Collection {...props} />
        </Container>
      </When>
      <Otherwise>
        <Collection {...props} />
      </Otherwise>
    </Choose>
  )
}

export default CollectionModuleWrapper
